import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Tag, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import _ from 'lodash'

import { observer } from 'mobx-react'

import type { TabType } from 'modules/core/components/Table/Tabs/types'

import './index.styles.css'
interface TabCounterProps<TabIds> {
  tab: TabType<TabIds>
  isSelected: boolean
}

function TabCounter<TabIds>({ tab, isSelected }: TabCounterProps<TabIds>) {
  const { color, counter } = tab

  if (counter == null) return null

  const type = isSelected ? color : Tag.Types.grey5
  const solid = isSelected

  return (
    <Tag type={type} size="small" solid={solid}>
      {counter}
    </Tag>
  )
}

interface TabButtonProps<TabIds> {
  tab: TabType<TabIds>
  isSelected: boolean
  onClick: (tab: TabType<TabIds>) => void
}

function TabButton<TabIds>({ tab, isSelected, onClick }: TabButtonProps<TabIds>) {
  const navigate = useNavigate()

  const onClickButton = (tab: TabType<TabIds>) => {
    return () => {
      onClick(tab)

      if (!tab.to) return

      navigate(tab.to)
    }
  }

  const { counter } = tab

  return (
    <button
      className={`${'Tab_tab'} ${isSelected ? 'isSelected' : ''}`}
      role="tab"
      id={`${tab.id}-tab`}
      aria-controls={`${tab.id}-panel`}
      aria-selected={isSelected}
      tabIndex={isSelected ? 0 : -1}
      onClick={onClickButton(tab)}
    >
      <Box gap="s12" flexDirection="row" alignItems="center">
        <span className={`${'Tab_label'} ${_.isNumber(counter) ? 'hasCounter' : ''}`}>
          {tab.label}
        </span>

        <TabCounter tab={tab} isSelected={isSelected} />
      </Box>
    </button>
  )
}

interface Props<TabIds> {
  tab: TabType<TabIds>
  isSelected: boolean
  onClick: (tab: TabType<TabIds>) => void
}

function Tab<TabIds>({ tab, isSelected, onClick }: Props<TabIds>) {
  const [open, toggle] = useToggle(false)

  if (!tab.tooltip) {
    return <TabButton tab={tab} isSelected={isSelected} onClick={onClick} />
  }

  return (
    <Tooltip
      attachment="bottom center"
      open={open}
      size="small"
      toggle={toggle}
      type={tab.tooltipColor || 'brand'}
    >
      <TabButton tab={tab} isSelected={isSelected} onClick={onClick} />
      <div>{tab.tooltip}</div>
    </Tooltip>
  )
}

export default observer(Tab)
